import { KFLButton } from '@kamstrup/kamstrup-frontend-library';
import React, { useEffect } from 'react';
import { msgRetryBtn } from '../../../core/localization/messages';
import { MessageType } from '../../../core/localization/model';
import { CallStatus } from '../../../models';
import { msgChecking } from '../../../modules/historical';
import { hasError } from '../../../utils/callStatus';
import FlaggedMsg, { FlagTypes } from '../flaggedMsg';
import Translate from '../localization/localize';
import Scrim from '../scrim';

type LatestLogsType = {
  status: CallStatus;
  msgLoader?: MessageType;
  getLatestLogs?: () => void;
};
const LatestLogs: React.FC<LatestLogsType> = ({
  status,
  msgLoader = msgChecking,
  getLatestLogs,
}) => {
  useEffect(() => {
    getLatestLogs?.();
  }, []);

  if (hasError(status))
    return (
      <>
        <FlaggedMsg label={status.errorMsg} type={FlagTypes.Error} />
        <KFLButton variant="borderless" onClick={getLatestLogs}>
          <Translate message={msgRetryBtn} />
        </KFLButton>
      </>
    );

  return <Scrim isActive={status.isFetching} label={msgLoader} iconSize={16} />;
};

export default LatestLogs;
